// @flow
import * as React from 'react'
import GatsbyLink from 'gatsby-link'
import { isRelativeUrl } from 'utils'

type Props = {
  href: string,
  children: React.Node,
  withAnchor?: boolean,
} & React.ElementProps<'a'>

const Link = ({ href, children, withAnchor = false, ...props }: Props) => {
  const url = typeof href === 'string' ? href : href.pathname
  if (!withAnchor && isRelativeUrl(url)) {
    return (
      <GatsbyLink to={href} {...props}>
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={href} {...props}>
      {children}
    </a>
  )
}

export default Link



// WEBPACK FOOTER //
// ./src/components/atoms/Link.js